<template>
    <v-card id="step-sidebar-card">
        <v-card-text>
            <v-row>
                <v-col cols="10" class="pb-0 d-flex align-center">
                    <div class="pa-0 prompt-title">
                        {{ $t("message.formSummit.applicationForm") }}
                    </div>
                </v-col>
                <v-col cols="2" id="studentFormDropDown" class="pb-0">
                    <v-btn icon @click="closeBar" 
                        ><v-icon id="dropbar-icon" size="20">mdi-menu-down</v-icon></v-btn
                    >
                </v-col>
            </v-row>
            <template v-if="this.closeActive">
                <v-row>
                    <v-col class="pb-0 pt-c-14">
                        <div class="pa-0 prompt-caption">
                            {{ $t("message.formSummit.school") }}
                        </div>
                        <div
                            class="pa-0 mt-1 text-caption"
                        >
                            {{ organization?.[`name_${locale}`] }}
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="px-auto py-c-14"> 
                        <v-divider></v-divider>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" sm="6" md="6" class="py-0"
                        ><div class="pa-0 mb-4 prompt-title">
                            {{ $t("message.formSummit.status") }}
                        </div></v-col
                    >
                    <v-col cols="8" sm="6" md="6" class="py-0"
                        ><div
                            class="pa-0 mb-4 prompt-title d-flex justify-end"
                        >
                            <div v-if="success">
                                <div v-if="windowWidth>960 && $t('message.formSummit.confirm').length > 12">
                                    <div>
                                        <v-chip class="ma-0" color="#EBEBEC">
                                            <v-icon color="#FF9800" left
                                                >mdi-checkbox-marked-circle</v-icon
                                            >
                                            <div class="prompt-chip pt-1">
                                                {{ $t("message.formSummit.confirm") }} 
                                            </div>
                                        </v-chip>
                                    </div>
                                </div>
                                <div v-else>
                                    <v-chip class="ma-0" color="#EBEBEC">
                                        <v-icon color="#FF9800" left
                                            >mdi-checkbox-marked-circle
                                        </v-icon>
                                        <div class="prompt-chip pt-1" >
                                            <span> 
                                                {{ $t("message.formSummit.confirm") }} 
                                            </span>
                                        </div>
                                    </v-chip>
                                </div>
                            </div>
                        </div></v-col
                    >
                    <v-col cols="12" sm="6" md="6" class="py-0 my-0">
                        <div class="pa-0 prompt-caption">
                            {{ $t("message.formSummit.initiationDay") }}
                        </div>
                        <div
                            class="pa-0 mt-1 mb-3 text-caption"
                        >
                            {{ enrollmentDate }}
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="pr-0 d-flex align-center" style="padding-top: 22px;"
                        ><div
                            class="pa-0 mt-0 mx-auto" 
                            style="
                                color: #37323c;
                                font-size: 14px !important; 
                             "
                        >
                            Customer Service LINE
                        </div></v-col
                    >
                    <v-col style="padding-top: 22px;"
                        ><v-img
                            :src="require('@/assets/lineBtn.svg')"
                            width="151"
                    /></v-col>
                </v-row>
            </template>
        </v-card-text>
    </v-card>
</template>

<script>
import { formatDateTime } from "@/utils/date";
import * as services from "@/services";
import i18n from '@/i18n';
export default {
    name: "StudentFormSummit",
    data() {
        return {
            show:false,
            closeActive: true,
            type: "pass",
            organization: null,
            windowWidth: window.innerWidth
        };
    },
    computed: {
        locale() {
            return i18n.locale
        },
        enrollmentDate() {
            let newDate = Date.parse(this.registrationFormDetail?.enrollment_date);
            if (newDate) return formatDateTime(newDate, this.locale);
            else return "";
        },
    },
    props: {
        step: Number,
        student_id: Number,
        registrationFormDetail: Object,
        success: Boolean,
    },
    methods: {
        closeBar() {
            if (this.closeActive) {
                document.getElementById("dropbar-icon").style.transform =
                    "rotate(180deg)";
                document.getElementById("height-overflow").style.height =
                    "180px";
            } else {
                document.getElementById("dropbar-icon").style.transform =
                    "rotate(0deg)";
                document.getElementById("height-overflow").style.height =
                    "480px";
            }
            this.closeActive = !this.closeActive;
        },
        async fetchOrganizationInfo() {
            try {
                this.$emit("updateLoading", 1);
                let data = await services.getOrganization();
                this.organization = data.data.data.organization;
            } finally {
                this.$emit("updateLoading", -1);
            }
        },
        onResize() {
            this.windowWidth = window.innerWidth
        }

    },
    mounted() {
        this.fetchOrganizationInfo();
        this.$nextTick(() => {
        window.addEventListener('resize', this.onResize);
        })
    },
    beforeDestroy() { 
        window.removeEventListener('resize', this.onResize); 
    },
};
</script>

<style scoped lang="scss">
.theme--light.v-icon.mdi-checkbox-blank-outline {
    color: #ff9800;
}

#studentFormDropDown{
    display: none;
}

@media only screen and (max-width: 959.98px) {
    #studentFormDropDown{
        display: block;
    }
}

#topic_bottom{
    padding-bottom: 7px;
}

#subtopic_top{
    padding-top: 7px;
}

/* margin custom 14*/
.mb-c-14{
    margin-bottom: 14px;
}

.pt-c-14{
    padding-top: 14px;
}

.py-c-14{
    padding-top: 14px;
    padding-bottom: 14px
}

.text-caption{
    color: #37323c;
    font-family: 'Sarabun' !important;
    font-size: 18px !important;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}

</style>
